export enum PdfProFormaType {
  ProForma = 0,
  ProFormaDeliveryFormStatement = 1,
}
